export default {
  entityName: "DocNumberSeries",
  apiEndpoint: "/master/doc-number-series",
  permissions: {
    view: "master:view",
    edit: "master:edit",
  },
  columns: [
    { key: "name", label: "Sequence Name", sortable: true },
    { key: "code", label: "Series Code", sortable: true, class: () => "font-mono font-bold" },
    { key: "prefix", label: "Prefix", sortable: true },
    { key: "sequence", label: "Next Sequence", sortable: true },
    { key: "fiscalYear", label: "Fiscal Year", sortable: true },
  ],
  fields: [
    { name: "name", label: "Sequence Name", type: "text", required: true, placeholder: "e.g. Sales Invoice Sequence" },
    { name: "code", label: "Series Code", type: "text", required: true, uppercase: true, placeholder: "e.g. INV-SEQ" },
    { name: "prefix", label: "Prefix String", type: "text", placeholder: "e.g. SINV-" },
    { name: "sequence", label: "Start Sequence No.", type: "number", required: true, default: 1, min: 1 },
    { name: "fiscalYear", label: "Fiscal Year", type: "text", required: true, placeholder: "e.g. 2026" },
    
    // Advanced options
    { name: "suffix", label: "Suffix String", type: "text", placeholder: "e.g. -IND", advanced: true },
    { name: "padding", label: "Number Padding Zeroes", type: "number", default: 5, min: 1, max: 10, advanced: true },
    { name: "resetStrategy", label: "Reset Strategy", type: "select", options: ["never", "yearly", "monthly", "daily"], default: "never", advanced: true },
    { name: "effectiveFrom", label: "Effective From", type: "date", advanced: true },
    { name: "effectiveTo", label: "Effective To", type: "date", advanced: true },
  ],
  filters: [],
  workflow: {
    type: "doc_number_series_approval",
    enabled: true,
  },
};
